'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _uiTranslations = require('@wh/ui-translations');

var _AnimatedSuccessMessageComponent = require('./AnimatedSuccessMessageComponent');

var _AnimatedSuccessMessageComponent2 = _interopRequireDefault(_AnimatedSuccessMessageComponent);

var _selectors = require('../../selectors');

var _actions = require('../../actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Maps the state to properties
 * @param {StateType} state The state map
 * @param {Object} props the container properties
 * @returns {Object} The properties to be passed to the SuccessMessage component
 */
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    statusMessage: (0, _selectors.statusMessageSelector)(state, props),
    currencyCode: (0, _selectors.currencyCodeSelector)(state, props)
  };
};

var mapDispatchToProps = {
  onClose: function onClose() {
    return (0, _actions.closingComponent)();
  }
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _uiTranslations.withTranslator)(_AnimatedSuccessMessageComponent2.default));